var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"pa-2",staticStyle:{"border":"1px solid black","width":"230px"},attrs:{"column":"","align-center":""}},[_c('h4',[_vm._v(_vm._s(_vm.stamp.title))]),_c('span',[_vm._v(_vm._s(_vm.stamp.line1))]),_c('span',[_vm._v(_vm._s(_vm.stamp.line2))]),_c('span',[_vm._v(_vm._s(_vm.stamp.line3))])])
}
var staticRenderFns = []

export { render, staticRenderFns }